import actions from './enquiry-form.actions.js';
import sendEnquiryActions from './send-enquiry.actions.js';
import trackingActions from './tracking.actions.js';

export default {
  ...actions,
  ...sendEnquiryActions,
  ...trackingActions,
};
